import { render, staticRenderFns } from "./Sensori.vue?vue&type=template&id=58f4c064&"
import script from "./Sensori.vue?vue&type=script&lang=js&"
export * from "./Sensori.vue?vue&type=script&lang=js&"
import style0 from "./Sensori.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports